import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';

interface ConsentProgressNoticeProps {
  answeredCount: number;
  totalCount: number;
  declinedRequiredTitles: string[];
}

export function ConsentProgressNotice({
  answeredCount,
  totalCount,
  declinedRequiredTitles,
}: ConsentProgressNoticeProps) {
  const { t } = useTranslation('clients');
  const hasDeclinedRequired = declinedRequiredTitles.length > 0;

  return (
    <div className="space-y-3">
      <p className="text-sm text-zoomuted text-center" aria-live="polite">
        {t('portal.consentGate.progress', { answered: answeredCount, total: totalCount })}
      </p>
      {hasDeclinedRequired === false ? null : (
        <div role="alert" className="flex items-start gap-2.5 px-4 py-3 bg-zoowarningbg rounded-xl">
          <Icon name="AlertCircle" className="text-zoowarningtext mt-0.5 shrink-0" />
          <div className="text-sm text-zoowarningtext leading-relaxed min-w-0">
            <p className="font-medium">{t('portal.consentGate.declinedRequiredWarning')}</p>
            <p className="mt-1">{declinedRequiredTitles.join(', ')}</p>
          </div>
        </div>
      )}
    </div>
  );
}
